import React, { useState } from "react";
import SignupContainer from "./SignupContainer";
import LoginContainer from "./LoginContainer.js";
import Cat from "../icons/cat.svg";

const AuthenticationModal = ({
  closeModalAfterAuthentication,
  errors,
  login,
  setErrors,
}) => {
  const [auth, switchAuth] = useState("login");

  return (
    <div className="auth-modal">
      <div className="modal-panel">
        <img src={Cat} alt="cat-icon" className="cat-icon" />
      </div>
      <div className="auth-form">
        {auth === "login" ? (
          <>
            <LoginContainer
              closeModalAfterAuthentication={closeModalAfterAuthentication}
              errors={errors}
              login={login}
              setErrors={setErrors}
            />
            <p
              className="auth-switch"
              onClick={() => {
                switchAuth("signup");
                setErrors({});
              }}
            >
              Don't have an account? <span className="auth-link">Sign Up</span>
            </p>
          </>
        ) : (
          <>
            <SignupContainer
              closeModalAfterAuthentication={closeModalAfterAuthentication}
              errors={errors}
              login={login}
              setErrors={setErrors}
            />
            <p
              className="auth-switch"
              onClick={() => {
                switchAuth("login");
                setErrors({});
              }}
            >
              Already signed up? <span className="auth-link">Log In</span>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthenticationModal;
